<script>
  import ToastConfetti_1 from '$icons/ToastConfetti1Icon.svelte';

  import LikeNotification from '$icons/LikeNotificationIcon.svelte';
  import CommentNotification from '$icons/CommentNotificationIcon.svelte';
  import BellIcon from '$icons/BellIcon.svelte';
  import ToastConfetti_2 from '$icons/ToastConfetti2Icon.svelte';
  import ToastConfetti_3 from '$icons/ToastConfetti3Icon.svelte';
  import CloseIconOutline from '$icons/CloseOutlineIcon.svelte';
  import { toast } from '@zerodevx/svelte-toast';
  import FollowedYouNotification from '$icons/FollowedYouNotificationIcon.svelte';
  import DonatedNotification from '$icons/DonatedNotificationIcon.svelte';
  import { goto } from '$app/navigation';

  export let title;
  export let type;
  export let toastId;

  const close = () => {
    toast.pop(toastId);
  };

  const notifs = () => {
    goto('/notifications');
  };
</script>

<div class="w-full max-w-[375px] py-4 text-black flex items-center justify-center cursor-pointer">
  <div class="w-full max-w-[350px] h-[75px] rounded-[20px] relative shadow-sidebar-item bg-white">
    <div class="-top-5 left-2 absolute z-50">
      <ToastConfetti_1 />
    </div>

    <div class="-bottom-2 left-2 absolute z-50">
      <ToastConfetti_2 />
    </div>

    <div class="top-2 -right-3 absolute z-50">
      <ToastConfetti_3 />
    </div>

    <div class="h-[6px] w-[6px] -top-3 left-14 absolute z-50 bg-brand-green-50 rounded-full" />
    <div class="h-[6px] w-[6px] right-3 top-3 absolute z-50 bg-[#FFAF50] rounded-full" />

    <div class="w-full h-full flex justify-between px-5 items-center">
      <button class="flex flex-row h-full items-center gap-3" on:click={notifs}>
        <div class="flex-shrink-0">
          {#if type === 'notif-like'}
            <LikeNotification />
          {:else if type === 'comment'}
            <CommentNotification />
          {:else if type === 'follow'}
            <FollowedYouNotification />
          {:else if type === 'notif-donation' || type === 'transaction'}
            <DonatedNotification />
          {:else}
            <BellIcon size="40" />
          {/if}
        </div>
        <div>{title}</div>
      </button>
      <button class="pr-4" on:click={close}>
        <CloseIconOutline />
      </button>
    </div>
  </div>
</div>
